import { render } from "./Titulos.vue?vue&type=template&id=56619216&scoped=true"
import script from "./Titulos.vue?vue&type=script&lang=js"
export * from "./Titulos.vue?vue&type=script&lang=js"

import "./Titulos.vue?vue&type=style&index=0&id=56619216&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56619216"]])

export default __exports__